module.exports = __webpack_public_path__ + "img/yl1.7b90cf32.webp";